import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { colors, fonts, spacing } from '../../constants';

/**
 * DialogHeader Component
 * Reusable dialog header with title and close button
 */
const DialogHeader = ({ title, onClose }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: spacing.md,
        py: spacing.sm,
        borderBottom: `1px solid ${colors.borderLight}`,
        background: colors.primaryGradient,
        borderRadius: '16px 16px 0 0',
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: fonts.weightBold,
          fontSize: '18px',
          color: colors.textWhite,
          letterSpacing: '-0.02em',
        }}
      >
        {title}
      </Typography>
      <IconButton
        onClick={onClose}
        sx={{
          color: colors.textWhite,
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            color: colors.textWhite,
          },
        }}
      >
        <Box sx={{ fontSize: '24px', lineHeight: 1 }}>×</Box>
      </IconButton>
    </Box>
  );
};

export default DialogHeader;
